import { useQuery } from "react-query";
import fetchWrapper from "utils/fetchWrapper";
import { AsyncResponseData, constructResponseData } from "utils/fetchWrapper/fetchWrapper";

type QueryParams = {
  localAccountId: string;
  documentVersionId: string;
};

interface Statistic {
  lastReadPage: number;
  lastReadProgression: number;
}

type Options= {
  isEnabled?: boolean;
  onSuccess?: (data: AsyncResponseData<Statistic>) => void
}
const getDocumentStatistics = async ({
  localAccountId,
  documentVersionId,
}: QueryParams) =>
  fetchWrapper.get(
    `${process.env.REACT_APP_BACK_END_API}/statistics?userId=${localAccountId}&documentVersionId=${documentVersionId}`
  );

export function useGetDocumentStatistics({
  localAccountId,
  documentVersionId,
}: QueryParams, {isEnabled, onSuccess}: Options={}) {
  return useQuery({
    retry: 3,
    cacheTime: 0,
    enabled: isEnabled,
    queryKey: ["document-statistics", { localAccountId, documentVersionId }],
    queryFn: async () => {
      const response = await getDocumentStatistics({
        localAccountId,
        documentVersionId,
      });
     const data = await constructResponseData<Statistic>(
        response,
        `Le chargement des statistics a échoué`
      );
      return data;
    },
    onSuccess
  });
}
